/**
 * Admin Resource Tags API Service (T060 - US5)
 * HTTP client for resource tags CRUD endpoints
 */

import { apiClient } from '@/core/api/client';
import type {
  AdminResourceTag,
  CreateResourceTagPayload,
  UpdateResourceTagPayload,
} from '../types/admin-resource.type';

const BASE_PATH = '/admin/resource-tags';

type ListResponse = {
  data: AdminResourceTag[];
  total: number;
};

type ListParams = {
  search?: string;
  isActive?: boolean;
};

export async function listResourceTags(
  params?: ListParams,
): Promise<AdminResourceTag[]> {
  const response = await apiClient.get<ListResponse>(BASE_PATH, { params });
  return response.data.data;
}

export async function createResourceTag(
  payload: CreateResourceTagPayload,
): Promise<AdminResourceTag> {
  const response = await apiClient.post<AdminResourceTag>(BASE_PATH, payload);
  return response.data;
}

export async function updateResourceTag(
  id: string,
  payload: Omit<UpdateResourceTagPayload, 'id'>,
): Promise<AdminResourceTag> {
  const response = await apiClient.patch<AdminResourceTag>(
    `${BASE_PATH}/${id}`,
    payload,
  );
  return response.data;
}

export async function deactivateResourceTag(
  id: string,
): Promise<AdminResourceTag> {
  const response = await apiClient.delete<AdminResourceTag>(
    `${BASE_PATH}/${id}`,
  );
  return response.data;
}

export const adminResourceTagsApi = {
  listResourceTags,
  createResourceTag,
  updateResourceTag,
  deactivateResourceTag,
};
